import React, { Component } from 'react';
import { connect } from 'react-redux';
import myPrivilegesCardViewRegistry from '../../../../registries/MyPrivilegesCardViewRegistry';
import { resolveLocalizedText } from '../../../../utils';
import './styles.scss';

export interface MyPrivilegesCardListProps {
  cardViewIds?: string[];
  additionalCards?: any;
}

export interface MyPrivilegesCardListState {}

export class MyPrivilegesCardList extends Component<
  MyPrivilegesCardListProps,
  MyPrivilegesCardListState
> {
  constructor(props: any = {}) {
    super(props);
  }

  render() {
    const { cardViewIds, additionalCards } = this.props;
    if (cardViewIds) {
      return (
        <div className="myprivileges-card-list-container">
          {myPrivilegesCardViewRegistry.renderCardView(cardViewIds)}
        </div>
      );
    } else {
      return null;
    }
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  MyPrivilegesCardList.mapStateToProps,
  MyPrivilegesCardList.mapDispatchToProps,
)(MyPrivilegesCardList);
